import type { QueryClient } from "@tanstack/react-query";
import { createOpenApiConfiguration } from "@/lib/utils";
import { LocationsApi } from "@/openapi/generated";
import { publicLocationsScrollQueryKey } from "@/lib/utils/prefetch/seedPublicQueryData";

export async function prefetchLocations(queryClient: QueryClient) {
  const service = new LocationsApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    // Use null (not undefined) so dehydrated keys match the client hook after JSON round-trip.
    queryKey: publicLocationsScrollQueryKey,
    queryFn: () => service.apiLocationsScrollGet({ page: 1, pageSize: 1000 }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
